import { useClient } from '@composables/use-clients';
import { GetRequestArgsType } from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetReviewResultRevieweeSkillActionsArgsType = GetRequestArgsType & {
  reviewCode: string;
  revieweeId: number;
  reviewSkillId: number;
};

export type GetReviewResultSkillActionsArgsType = GetRequestArgsType & {
  reviewCode: string;
  reviewSkillId: number;
};

export type GetReviewResultSkillCoveragesArgsType = GetRequestArgsType & {
  reviewCode: string;
};

export const apiFetchReviewResultRevieweeSkillActions = async ({
  domain = useTenantStore().domain,
  reviewCode,
  revieweeId,
  reviewSkillId,
  errorConfig = {},
  callbacks = {},
}: GetReviewResultRevieweeSkillActionsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.reviewResultRevieweeSkillActions({
        domain,
        reviewCode,
        revieweeId,
        reviewSkillId,
      }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiFetchReviewResultReviewSkillReviewSkillActions = async ({
  domain = useTenantStore().domain,
  reviewCode,
  reviewSkillId,
  errorConfig = {},
  callbacks = {},
}: GetReviewResultSkillActionsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.reviewResultReviewSkillReviewSkillActions({
        domain,
        reviewCode,
        reviewSkillId,
      }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiFetchReviewResultSkillCoverages = async ({
  domain = useTenantStore().domain,
  reviewCode,
  errorConfig = {},
  callbacks = {},
}: GetReviewResultSkillCoveragesArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.reviewResultSkillCoverages({ domain, reviewCode }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
